import React, { Component, createRef, Fragment } from 'react';
import { Text } from '@movember/mo-gel';

import { ReactComponent as TrueNorthLogo } from '../assets/logos/true_north_logo_black.svg';
import {
  StyledHomeIcon,
  StyledHeaderContainer,
  StyledLogoLink,
  StyledMenuItemLink,
  StyledMenuList,
  StyledMenuListItem,
  PopoverMenuContainer,
  PopoverMenuItem,
  PopoverMenuLink,
  StyledLinkTextWrapper,
  StyledMenuToggle,
  StyledMobileContainer,
  StyledSubLinkContainer
} from './Header.styled';
import { OverlayPanel } from '../OverlayPanel';

export class Header extends Component {
  constructor(props) {
    super(props);
    const { language } = this.props;
    this.menuItemRef = createRef();

    this.trueNthUrl = process.env.REACT_APP_BASE_URL || '';
    this.urlWithLanguage = `/${language || 'en'}`;
    this.languages = {
      gb: 'en-gb',
      ie: 'en-ie',
      au: 'en-au'
    };

    this.menLikeMeUrl = `${this.urlWithLanguage}/men-like-me/`;
    this.lapcdUrl = `${this.urlWithLanguage}/life-after-prostate-cancer-diagnosis/`;
    this.ipcorUrl = `${this.urlWithLanguage}/ipcor/`;
    this.pcorAusUrl = 'https://prostatecancerregistry.org';

    this.navLinks = [
      {
        link: this.menLikeMeUrl,
        children: 'Men Like Me',
        hideLink: language !== this.languages.gb
      },
      {
        link: language === this.languages.ie ? this.ipcorUrl : this.pcorAusUrl,
        target: language === this.languages.au ? '_blank' : '',
        children: 'Prostate Cancer Registry',
        hideLink: language !== this.languages.ie && language !== this.languages.au
      },
      {
        link: '/',
        children: 'About',
        displayLink: true,
        subLinks: [
          {
            link: `${this.urlWithLanguage}/coming-soon/`,
            children: 'Coming Soon',
            hideLink: language !== this.languages.au
          },
          {
            link: `${this.urlWithLanguage}/about/true-north/`,
            children: 'About True North'
          },
          {
            link: `${this.urlWithLanguage}/about/prostate-cancer/`,
            children: 'About Prostate Cancer'
          },
          {
            link: this.lapcdUrl,
            children: `Life After Prostate
Cancer Diagnosis`,
            hideLink: language !== this.languages.gb
          }
        ]
      },
      {
        link: `${this.urlWithLanguage}/`,
        children: (
          <>
            Home
            <StyledHomeIcon />
          </>
        )
      }
    ];

    this.state = {
      isDesktop: false,
      isMobileNavDisplayed: false
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { onBlur } = this.props;
    this.setState({ isDesktop: window.innerWidth >= 1024, isMobileNavDisplayed: false });
    onBlur(false);
  };

  toggleNavigation = () => {
    const { onBlur } = this.props;
    const { isMobileNavDisplayed } = this.state;
    this.setState({ isMobileNavDisplayed: !isMobileNavDisplayed });

    onBlur(!isMobileNavDisplayed);
  };

  menuItem = ({ link, target, children, hideLink, subLinks }, index) => {
    return hideLink ? null : (
      <StyledMenuListItem hasPopover={subLinks} key={`main-link-${index}`}>
        <StyledMenuItemLink href={link} target={target}>
          {children}
        </StyledMenuItemLink>

        {subLinks && (
          <PopoverMenuContainer>
            {subLinks.map((subLink, subIndex) => {
              return subLink.hideLink ? null : (
                <PopoverMenuItem key={`sub-link-${subIndex}`}>
                  <PopoverMenuLink href={subLink.link}>
                    <StyledLinkTextWrapper>{subLink.children}</StyledLinkTextWrapper>
                  </PopoverMenuLink>
                </PopoverMenuItem>
              );
            })}
          </PopoverMenuContainer>
        )}
      </StyledMenuListItem>
    );
  };

  mobileMenuItem = ({ link, target, children, hideLink, subLinks }, index) => {
    return hideLink ? null : (
      <Fragment key={`fragment-${index}`}>
        {!subLinks && (
          <StyledMenuListItem hasPopover={subLinks} key={`main-link-${index}`}>
            <StyledMenuItemLink href={link} target={target}>
              {children}
            </StyledMenuItemLink>
          </StyledMenuListItem>
        )}

        {subLinks && (
          <StyledSubLinkContainer>
            <Text color="#000000">{children}</Text>
            {subLinks.map((subLink, subIndex) => {
              return subLink.hideLink ? null : (
                <StyledMenuListItem key={`sub-link-${subIndex}`}>
                  <StyledMenuItemLink href={subLink.link} target={subLink.target}>
                    {subLink.children}
                  </StyledMenuItemLink>
                </StyledMenuListItem>
              );
            })}
          </StyledSubLinkContainer>
        )}
      </Fragment>
    );
  };

  render() {
    const { isDesktop, isMobileNavDisplayed } = this.state;

    const sortedMobileNav = [...this.navLinks].reduce((accumulator, nav) => {
      if (nav.subLinks) {
        return [nav, ...accumulator];
      }
      return [...accumulator, nav];
    }, []);
    const mobileNav = [...sortedMobileNav].reverse();

    return (
      <StyledHeaderContainer ref={this.menuItemRef}>
        <StyledLogoLink href={this.urlWithLanguage} alt="home logo link">
          <TrueNorthLogo />
        </StyledLogoLink>

        <StyledMenuList>
          {isDesktop ? (
            this.navLinks.map((navLink, index) => {
              return this.menuItem(navLink, index);
            })
          ) : (
            <StyledMenuListItem>
              <StyledMenuItemLink onClick={this.toggleNavigation}>
                {isMobileNavDisplayed ? 'Close' : 'Menu'}
                <StyledMenuToggle>
                  <input type="checkbox" checked={isMobileNavDisplayed} onChange={this.toggleNavigation} />
                  <span />
                  <span />
                  <span />
                  <div />
                </StyledMenuToggle>
              </StyledMenuItemLink>

              {isMobileNavDisplayed && (
                <OverlayPanel target={this.menuItemRef.current} direction="slide-down" type="fullScreen">
                  <StyledMobileContainer>
                    {mobileNav.map((navLink, index) => {
                      return this.mobileMenuItem(navLink, index);
                    })}
                  </StyledMobileContainer>
                </OverlayPanel>
              )}
            </StyledMenuListItem>
          )}
        </StyledMenuList>
      </StyledHeaderContainer>
    );
  }
}
